import ShareByEmail from './ShareByEmail';

export default ShareByEmail;
